/** Máquina de estados del pedido (spec 7.1). */
export type OrderStatus =
  | 'paid'
  | 'preparing'
  | 'shipped'
  | 'in_transit'
  | 'delivered'
  | 'completed'
  | 'cancelled'
  | 'refunded'
  | 'disputed';

export const ORDER_STATUSES: OrderStatus[] = [
  'paid',
  'preparing',
  'shipped',
  'in_transit',
  'delivered',
  'completed',
  'cancelled',
  'refunded',
  'disputed',
];

export const ORDER_STATUS_LABELS: Record<string, string> = {
  paid: 'Pagado',
  preparing: 'Preparando',
  shipped: 'Enviado',
  in_transit: 'En tránsito',
  delivered: 'Entregado',
  completed: 'Completado',
  cancelled: 'Cancelado',
  refunded: 'Reembolsado',
  disputed: 'En disputa',
};

/** Evento del historial del pedido (estados + eventos DHL + ledger + tickets). */
export interface OrderHistoryEvent {
  id?: number;
  status?: string;
  type?: string;
  description?: string;
  actor?: string;
  adminUserId?: number;
  reason?: string;
  createdAt?: string;
  date?: string;
  [key: string]: unknown;
}

/** Envío (guía DHL). */
export interface Shipment {
  id?: number;
  paymentId?: number;
  offerId?: number;
  trackingNumber?: string;
  carrier?: string;
  status?: string;
  labelUrl?: string;
  createdAt?: string;
  events?: TrackingEvent[];
  [key: string]: unknown;
}

/** Evento de tracking DHL. */
export interface TrackingEvent {
  date?: string;
  timestamp?: string;
  status?: string;
  statusCode?: string;
  description?: string;
  location?: string;
  [key: string]: unknown;
}
